import React, { FC } from 'react';
import Modal from '@components/Modal';
import Button from '@/components/DesignLibrary/Button';
import WarningCircle from '@/components/Icons/WarningCircle';
import s from './InvalidDocumentModal.module.scss';

type Props = {
  isInvalidDocModalOpen: boolean;
  setInvalidDocModalOpen: (open: boolean) => void;
  encryptedDocuments?: string[];
};

const InvalidDocumentModal: FC<Props> = ({ setInvalidDocModalOpen, encryptedDocuments = [] }) => (
  <Modal hasPadding onClose={() => setInvalidDocModalOpen(false)} title="">
    <div className={s.modalHeader}>
      <WarningCircle size={96} weight="fill" color="var(--color-warning)" />
      <h2 className="body-lg-bold">
        {
          encryptedDocuments.length > 1 ? 'Some files are locked' : 'File is locked'
        }
      </h2>
      <p className={[s.modalBodyText, s.modalTextWarning].join(' ')}>
        Please unlock the file(s), save the changes, and re-upload it. Let us know if you need any assistance!
      </p>
      {
        encryptedDocuments.length > 0 && (
          <>
            <p>
            The following files are locked:
            </p>
            <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
              <ul>
                {
                  encryptedDocuments.map((doc) => (
                    <li key={doc}>{doc}</li>
                  ))
                }
              </ul>
            </div>
          </>
        )
      }
    </div>
    <div className={s.modalBody}>
      <div className={s.modalBodyButtons}>
        <Button
          size="md"
          className={s.modalBodyButton}
          variant="primary"
          onClick={() => {
            setInvalidDocModalOpen(false);
          }}
        >
                    Continue
        </Button>
      </div>
    </div>
  </Modal>
);

export default InvalidDocumentModal;